import { motion } from "framer-motion"
import { memo } from "react"

interface HeroCaretAnimationProps {
  id: number
  pathX: number[]
  pathY: number[]
}

export const HeroCaretAnimation = memo(function HeroCaretAnimation({ id, pathX, pathY }: HeroCaretAnimationProps) {
  return (
    <motion.svg
      key={id}
      className="absolute pointer-events-none z-30"
      width="12"
      height="12"
      viewBox="0 0 56 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Trading up caret"
      style={{
        top: "11.4px",
        left: "40%",
        transform: "translateX(-50%)",
        filter: "drop-shadow(0 0 3px #22FF65) drop-shadow(0 0 6px #22FF65)",
      }}
      initial={{ opacity: 0, scale: 1, y: 0, x: 0 }}
      animate={{
        opacity: [0, 0.3, 1, 1, 0.8, 0],
        scale: [0.3, 0.6, 0.8, 1, 0.9, 0.7],
        y: pathY,
        x: pathX,
        filter: [
          "blur(2px) drop-shadow(0 0 2px #22FF65)",
          "blur(1px) drop-shadow(0 0 3px #22FF65)",
          "blur(0px) drop-shadow(0 0 3px #22FF65) drop-shadow(0 0 6px #22FF65)",
          "blur(0px) drop-shadow(0 0 3px #22FF65) drop-shadow(0 0 6px #22FF65)",
          "blur(0px) drop-shadow(0 0 2px #22FF65)",
          "blur(2px) drop-shadow(0 0 1px #22FF65)",
        ],
      }}
      transition={{
        duration: 1.1,
        ease: [0.25, 0.46, 0.45, 0.94],
        times: [0, 0.1, 0.2, 0.3, 0.7, 1],
      }}
    >
      <title>Trading up caret</title>
      <path
        d="M119.24 48.03L117.23 54.29H64.7502L62.7402 48.03L90.9402 6.75L119.24 48.03Z"
        fill="#22FF65"
        transform="translate(-62, -6) scale(1, 1)"
      />
    </motion.svg>
  )
})
